import { CreateGoalModal } from "pages/Solutions/Performance/CreateGoalModal";
import { GoalList } from "pages/Solutions/Performance/GoalDisplay";
import { useState } from "react";
import { useHistory } from "react-router";

export type GoalWidgetsProps = {
  userId: string;
};

export const GoalWidgets = ({ userId }: GoalWidgetsProps) => {
  const history = useHistory();

  const [creatingGoal, setCreatingGoal] = useState(false);

  const onReviewGoal = (goalId: string) => {
    history.push(`/solutions/people/goals/${goalId}/review/${userId}`);
  };

  return (
    <>
      <CreateGoalModal
        isOpen={creatingGoal}
        onCancel={() => setCreatingGoal(false)}
        directReportId={userId}
      ></CreateGoalModal>

      <GoalList
        reviewGoal={(goalId) => onReviewGoal(goalId)}
        userId={userId}
        createGoal={() => setCreatingGoal(true)}
      />
    </>
  );
};
